export default __webpack_public_path__ + "img/bbw/bx_logo.svg";